import React, { Fragment } from "react";
import classNames from "classnames";
import localStyles from "./header.scss";

const headerColums = () => {
    const rowStyle = {
        marginLeft: "-10px",
        display: "flex",
        height: "inherit",
        flexDirection: "row",
        alignItems: "center",
    };
    const colStyle = { width: "10%" }; //

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
            }}
        >
            <div style={{ textAlign: "center" }}> Name</div>
            <div style={{ textAlign: "center" }}> Vorname</div>
            <div style={{ textAlign: "center" }}> Funktion</div>
            <div style={{ textAlign: "center" }}> Personen Nr.</div>
        </div>
    );

    return hC;
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    aditionalParams = ""
) => {
    return <div></div>;
};
const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = "",
    data
) => {
    const roles = data.teamRoleList;

    const renderContent = () => {
        switch (displayProperty) {
            case "firstName":
                return item.firstName;
            case "lastName":
                return item.lastName;
            case "role":
                return roles[item[displayProperty]] || "";
            case "salutation":
                return item[displayProperty] || "";
            default:
                return null;
        }
    };

    return (
        <div
            className={itemColumnClass}
            key={`${displayProperty}-${item.id}`}
            name={displayProperty}
            style={
                displayProperty !== "shirtNumber"
                    ? { textAlign: "center", paddingLeft: "0px" }
                    : { paddingLeft: "10px" }
            }
        >
            {renderContent()}
        </div>
    );
};
const footer = (noOfSelectedPlayer) => {};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
